import './App.css';
import AppRouter from './config/routes/router';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { ReactQueryProvider } from './lib/react-query';
import { Toaster } from './components/ui/toaster';

function App() {
  return (
    <ReactQueryProvider>
      <AuthProvider>
        <ThemeProvider>
          <div className="App">
            <AppRouter />
            <Toaster />
          </div>
        </ThemeProvider>
      </AuthProvider>
    </ReactQueryProvider>
  );
}

export default App;
